import { cx } from "class-variance-authority";
import { useTranslation } from "react-i18next";

import { ShortlistBoxItem } from "@/components/shortlist/ShortlistBoxItem";
import { Typography } from "@/components/ui/text/Typography/Typography";
import { BizShortlistQueries } from "@/data/bizShortlist/bizShortlist.queries";

interface ShortlistProps {
  isHidden?: boolean;
}

export const Shortlist = ({ isHidden = false }: ShortlistProps) => {
  const { t } = useTranslation();
  const { data: shortlist, isLoading: isShortlistLoading } = BizShortlistQueries.useGetShortlist();

  if (isShortlistLoading) return null;

  return (
    <div
      className={cx(
        "mx-auto flex w-full max-w-[912px] flex-col gap-2 transition-all duration-500 ease-out",
        isHidden ? "overflow-none pointer-events-none max-h-0 opacity-0" : "opacity-100",
      )}
    >
      <Typography
        size="label-4"
        variant="prominent-1"
        className="mb-2 text-text-inverted-secondary"
      >
        {t("shortlist.title")}
      </Typography>
      {!shortlist?.positions?.length && (
        <div className="flex h-28 w-full items-center justify-center rounded-xs border border-elevation-outline-1">
          <Typography
            size="label-4"
            variant="prominent-1"
            className="text-text-inverted-secondary"
          >
            {t("shortlist.noJobSalary")}
          </Typography>
        </div>
      )}
      <div className="flex flex-row flex-wrap gap-5">
        {shortlist?.positions?.map((jobId) => (
          <ShortlistBoxItem
            key={jobId}
            jobId={jobId}
          />
        ))}
      </div>
    </div>
  );
};
